// extracted by mini-css-extract-plugin
module.exports = {"keyPoints":"jibTableStyles_keyPoints__piKYL","reasons":"jibTableStyles_reasons__Zqpgz"};